import React from 'react';

const CollectionDeliverySection = ({ collectionDeliveryOption, collectionDistance }) => (
  <div>
    {collectionDeliveryOption}
    {collectionDeliveryOption === 'GarageC&D' && (
      <span>
        {': '}
        <b>{`${collectionDistance} miles`}</b>
      </span>
    )}
  </div>
);

export default CollectionDeliverySection;
